module.exports = __webpack_public_path__ + "media/images/new/filter_by_elevation@2x-68aea0ea806b345c393efa4b1b478e11.jpg";